import React, {
  Component
} from 'react';
import VisitorIndex from './visitor/VisitorIndex';
import Admin from './Admin/Admin';
import About from './visitor/About/About';
import TnC from './visitor/TnC';
import Solution from './visitor/Solution/Solution';
import SpecialOffer from './visitor/SpecialOffer/SpecialOffer';
import {
  Route,
  BrowserRouter as Router,
  Switch
} from 'react-router-dom'

// import "./visitor/assets/css/materialize.css"
import "./visitor/assets/css/style.css"

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={VisitorIndex}/>
          <Route path="/about" component={About}/>
          <Route path="/tnc" component={TnC}/>
          <Route path="/solution" component={Solution}/>
          <Route path="/specialoffer" component={SpecialOffer}/>
          <Route path="/admin" component={Admin}/>
        </Switch>
      </Router>
    )
  }
}

export default App;